<template>
  <div class="c-text">
    <div class="c-col-field">{{ isButton ? tip[0] : description }}</div>
    <input-len v-model="text" charset="init" :placeholder="`请输入${description}`" :max="max" bc width="420"></input-len>
    <div class="c-col-description" v-if="isButton">{{ tip[1] }}</div>
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixinVerify from './mixin-verify'
import InputLen from '@/components/input/input-len.vue'
import { getByteLen } from '@/common/js/utils'
export default {
  name: 'cText',
  mixins: [mixinVerify],
  components: { InputLen },
  props: {
    name: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      type: [String, Number]
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    required: {
      type: Boolean
    },
    pattern: {
      type: String
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    text: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      if (this.text) {
        return getByteLen(this.text)
      } else {
        return 0
      }
    },
    isButton() {
      const index = this.description.indexOf('，')
      return this.name === 'button_text' && index > -1
    },
    tip() {
      if (this.isButton) {
        const index = this.description.indexOf('，')
        return [this.description.substring(0, index), this.description.substring(index + 1)]
      } else {
        return ''
      }
    }
  },
  watch: {
    value(nVal) {
      this.$emit('on-change', nVal)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-text {
  position: relative;
  z-index: 998;

  .c-col-field {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    position: absolute;
    width: 140px;
    line-height: 32px;
    text-align: right;
    top: 0;
    left: -165px;
  }

  .c-col-description {
    margin-top: 5px;
    line-height: 25px;
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 0;
    bottom: -16px;
    color: #ff4400;
  }
}
</style>
